<template>
  <v-card class="pa-4 elevation-1">
    <div class="d-flex align-center justify-space-between flex-wrap">
      <v-card-title class="text-subtitle-1 font-weight-bold pa-0">
        {{ $t('surveys.nps.distribution_title') }}
      </v-card-title>
      <vue-json-to-csv
        :json-data="exportRows"
        :labels="exportLabels"
        :csv-title="exportFilename"
        separator=";"
      >
        <v-btn text small color="deep-purple lighten-1">
          <v-icon left small>mdi-download</v-icon>
          {{ $t('surveys.export.button') }}
        </v-btn>
      </vue-json-to-csv>
    </div>
    <v-card-text>
      <div v-for="score in scores" :key="score" class="mb-2">
        <div class="d-flex justify-space-between text-caption mb-1">
          <span class="font-weight-bold">{{ score }}</span>
          <span class="grey--text">
            {{ countFor(score) }} · {{ formatPct(percentageFor(score)) }}
          </span>
        </div>
        <v-progress-linear
          :value="percentageFor(score)"
          :color="colorFor(score)"
          height="14"
          rounded
        />
      </div>
    </v-card-text>
  </v-card>
</template>

<script>
import VueJsonToCsv from 'vue-json-to-csv';
import { npsScoreColor } from '@/utils/nps';

const SCORES = ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10'];

export default {
  name: 'NpsDistribution',
  components: { VueJsonToCsv },
  props: {
    distribution: { type: Object, default: () => ({}) },
    n: { type: Number, default: 0 },
    campaignName: { type: String, default: '' },
  },
  data: () => ({ scores: SCORES }),
  computed: {
    exportRows() {
      return this.scores.map((score) => ({
        score,
        count: this.countFor(score),
        percentage: this.formatPct(this.percentageFor(score)),
      }));
    },
    exportLabels() {
      return {
        score: { title: this.$t('surveys.export.col_score') },
        count: { title: this.$t('surveys.export.col_count') },
        percentage: { title: this.$t('surveys.export.col_percentage') },
      };
    },
    exportFilename() {
      return `distribucion_${this.campaignName}_${new Date().toISOString().slice(0, 10)}`;
    },
  },
  methods: {
    countFor(score) {
      return this.distribution[score] || 0;
    },
    percentageFor(score) {
      return this.n > 0 ? (this.countFor(score) / this.n) * 100 : 0;
    },
    colorFor(score) {
      return npsScoreColor(Number(score));
    },
    formatPct(value) {
      return `${Math.round(value || 0)}%`;
    },
  },
};
</script>
